import axios from "axios";
import router, {resetRouter} from '../router'
import cache from "utils/cache";
import { isSsoMode, markSsoMode, clearSsoMode } from 'utils/sso'

const BASEURL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API : process.env.VUE_APP_API;
const _OK = 200
const _FOUND = 302
const _MOVED_PERMANENTLY = 301
const _UNAUTHORIZED = 401
const _FORBIDDEN = 403
const _NOT_FOUND = 404
const _GATEWAY_TIMEOUT = 504

const service = axios.create({
  baseURL: BASEURL, //根路径
  timeout: 300000 //超时
})

/**
 * 请求接口前，做一些数据处理（请求拦截器）
 */
service.interceptors.request.use(
  function(config) {
    if (!config.headers) config.headers = {};
    const token = cache.get('device-Token');
    if (token) {
      config.headers['backoffice-token'] = token;
    }
    return config
  },
  function(error) {
    return Promise.reject(error);
  }
)
/**
 * 请求接口后，返回数据进行拦截（响应拦截器）
 */
service.interceptors.response.use(
  function(response) {
    const status = response.status
    let data = response.data
    // console.log('+++++++++++++++response',response);
    if(status === _UNAUTHORIZED) {
        let isSSO = isSsoMode();
        cache.clear();
        resetRouter();
        if (isSSO){
            markSsoMode();
            router.replace({
                path: "/auth"
            })
        }else {
            router.replace({
                path: "/login"
            })
        }

        this.$message.error('登录超时！');
        return Promise.reject(data)
    }
    if(status == _OK) {
      if(data.code == 0) {
        return Promise.resolve(data)
      }else {
        return Promise.reject(data)
      }
    }else {
      return Promise.reject(data)
    }
  },
  function(error) {
    const status = error.response.status
    if(status === _UNAUTHORIZED) {
        let isSSO = isSsoMode();
        cache.clear();
        resetRouter();
        if (isSSO){
            markSsoMode();
            router.replace({
                path: "/auth"
            })
        }else {
            router.replace({
                path: "/login"
            })
        }
    }
    else {
      return Promise.reject(error)
    }
  }
)

export default service.request
